import type { SnapshotFrom } from 'xstate';
import type { RegisterHiveInput } from '@/lib/gql/__generated__/graphql';
import { feature, useFeature } from '@/app/context';
import { hiveMachine } from './hive.machine';

export const useHiveRef = () => feature('hive');
export const useHive = <R>(selector: (snapshot: SnapshotFrom<typeof hiveMachine>) => R) => useFeature('hive', selector);

export const useHiveActions = () => {
  const ref = useHiveRef();
  return {
    loadHives: () => ref.send({ type: 'hive.load-hives' }),
    openRegister: () => ref.send({ type: 'hive.open-register' }),
    register: (input: Omit<RegisterHiveInput, 'hiveId'>) => ref.send({ type: 'hive.register', input }),
  };
};
